import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import translationEN from './translations/locales/en/translation.json'
import translationDE from './translations/locales/de/translation.json'
import translationFR from './translations/locales/fr/translation.json'

const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
  fr: {
    translation: translationFR,
  },
}

i18n.use(initReactI18next).init({
  resources,
  // lng: 'de',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
